import * as React from "react";
const SvgPodium = (props) => /* @__PURE__ */ React.createElement("svg", { fill: "none", height: 24, width: 24, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 21 26", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 0.5V15.2341L7.07717 25.5H15.2743L10.9799 15.2341H20.6546V0.5H0Z", fill: "currentColor" }));
export default SvgPodium;
